import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

//    Initialize Sentry (optional)
Sentry.init({
  dsn: environment.sentryDsn,
  sendDefaultPii: true,
  environment: environment.name,
  integrations: [
    Sentry.replayIntegration()
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
Sentry.setTag('env', environment.name);

//    Bootstrap the standalone app
bootstrapApplication(AppComponent, appConfig).catch(err =>
  console.error('  Bootstrap error:', err)
);
